import React from "react";

import {
  Box,
  HStack,
  Text,
} from "@whoosh/design-system/src/components/primitive";

type DetailRowProps = {
  icon: React.ReactNode;
  label: string;
  value: string | number;
};

export const DetailRow = ({ icon, label, value }: DetailRowProps) => (
  <HStack
    justifyContent="space-between"
    paddingBottom={2}
    paddingTop={2}
    alignItems="center"
  >
    <HStack gap={3} alignItems="center">
      <Box
        width={24}
        height={24}
        backgroundColor="surface-main-primary-subtlest"
        justifyContent="center"
        alignItems="center"
        borderRadius="1"
      >
        {icon}
      </Box>
      <Text variant="mainBaseSemiBold">{label}</Text>
    </HStack>
    <Text variant="mainBaseSemiBold">{value}</Text>
  </HStack>
);
